import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-system-status-nav',
    templateUrl: './system-status-nav.component.html',
    styleUrls: ['./system-status-nav.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SystemStatusNavComponent implements OnInit {
  @Input() page: string;

  constructor() {}

  ngOnInit(): void {}
}
